import { configureStore } from '@reduxjs/toolkit';
import calendarReducer from '@/slices/calendar-slice';
import baseApi from '@/slices/meeting-md-api-slice';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    calendar: calendarReducer,
  },
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().concat(baseApi.middleware);
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
